import type { FC, ReactNode } from "react";

import { PageGridHeaderRow } from "./PageGridHeaderRow";
import { PageRow } from "./PageRow";

import { type PageType, SectionKind } from "components/server-types";
import { ScrollableTableContainer } from "components/tables/ScrollableTableContainer";
import { AccordionTitle } from "mds/components/AccordionTitle";

export const PageAccordionSection: FC<{
  pages: PageType[];
  sectionKind?: SectionKind;
  title: ReactNode;
  startOpen?: boolean;
}> = ({ pages, sectionKind, title, startOpen = true }) => {
  if (!pages.length) {
    return null;
  }

  return (
    <AccordionTitle
      className="py-3"
      collapsedHeaderClassName="justify-between py-0 border-b border-black-tint-90"
      headerClassName="justify-between py-0"
      iconPosition="end"
      startOpen={startOpen}
      title={title}
    >
      <ScrollableTableContainer className="mb-0 w-full">
        <PageGridHeaderRow sectionKind={sectionKind} />

        <div role="rowgroup">
          {pages.map((page) => (
            <PageRow key={page.id} page={page} sectionKind={sectionKind} />
          ))}
        </div>
      </ScrollableTableContainer>
    </AccordionTitle>
  );
};
